import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { GoogleOAuthProvider } from "@react-oauth/google";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AwaitingApprovalPage from "@/pages/AwaitingApprovalPage";
import AuthCallback from "@/pages/AuthCallback";

import UserDashboard from "@/pages/UserDashboard";
import CourseViewer from "@/pages/CourseViewer";
import ProfilePage from "@/pages/ProfilePage";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import PendingUsersPage from "@/pages/admin/PendingUsersPage";
import AllUsersPage from "@/pages/admin/AllUsersPage";
import BulkUploadPage from "@/pages/admin/BulkUploadPage";
import ModulesPage from "@/pages/admin/ModulesPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import CertificatesPage from "@/pages/CertificatesPage";
import VerifyCertificatePage from "@/pages/VerifyCertificatePage";


function AppRoutes() {
  const location = useLocation();
  // Handle Emergent Google OAuth callback hash on any route
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/awaiting-approval" element={<AwaitingApprovalPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/verify/:certId" element={<VerifyCertificatePage />} />

      <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
      <Route path="/course/:slug" element={<ProtectedRoute><CourseViewer /></ProtectedRoute>} />
      <Route path="/certificates" element={<ProtectedRoute><CertificatesPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />

      <Route path="/admin" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/pending" element={<ProtectedRoute roles={["admin", "super_admin"]}><PendingUsersPage /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute roles={["admin", "super_admin"]}><AllUsersPage /></ProtectedRoute>} />
      <Route path="/admin/bulk-upload" element={<ProtectedRoute roles={["admin", "super_admin"]}><BulkUploadPage /></ProtectedRoute>} />
      <Route path="/admin/modules" element={<ProtectedRoute roles={["admin", "super_admin"]}><ModulesPage /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute roles={["super_admin"]}><SettingsPage /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID.apps.googleusercontent.com";
  
  return (
    <div className="App">
      <GoogleOAuthProvider clientId={googleClientId}>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </div>
  );
}
